import { JobService } from './../service/job.service';
import { Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { dreamjobs_txt, dreamjobspro_txt, espectador_txt, activos_txt, txt_hv, txt_hv1, txt_hv2 } from '../texts/text';


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  companyName = '';
  dir_name = '';
  titleCompany = '';
  imgchatbots_dir = '';
  imgkanban_dir = '';
  imgbd_dir = 'assets/images/feat_3.png';
  imgpc_dir = 'assets/images/feat_4.png';
  imggd_dir = 'assets/images/feat_5.png';
  imgfc_dir = 'assets/images/feat_6.png';
  logo = '';
  txt: any;
  txthv: any;
  sizeAll: number;
  jobsAll: any;
  pagesAll: number;
  maxAll = 6;
  onloadingAll = true;
  pageAll = 1;
  totalAll = 1;
  pageofer: string = '0';

  video_dir = 'assets/images/dreamjobs/video.mp4';


  sizeUrgent: number;
  jobsUrgent: any;
  pagesUrgent: number;
  maxUrgent = 6;
  onloadingUrgent = true;
  pageUrgent = 1;
  totalUrgent = 1;
  searchAll = '';
  searchCompany = '';
  searchUrgent = '';
  searchCity = '';

  sizeCompany: number;
  jobsCompany: any;
  jobsCompanySlice: any;
  pagesCompany: number;
  maxCompany = 6;
  onloadingCompany = true;
  pageCompany = 1;
  totalCompany = 1;

  sizeCity: number;
  jobsCity: any;
  jobsCitySlice: any;
  pagesCity: number;
  maxCity = 6;
  onloadingCity = true;
  pageCity = 1;
  totalCity = 1;

  urlJob = "https://user.dreamjobs.com.co/job/";

  latitude = 4.6773589;
  longitude = -74.0601957;
  message = 'Obteniendo tu localización, esto puede tardar unos segundos';
  geolocationPosition: any;
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jobService: JobService
  ) { }


   ngOnInit() {
    //  console.log(this.video_dir);
    this.route.params.subscribe(params => {
      this.companyName = params['companyName'];
      this.dir_name = 'assets/images/' + this.companyName + '/';
        switch (this.companyName) {
          case 'dreamjobs':
             this.companyName = this.companyName;
             this.titleCompany = 'Dreamjobs';
             this.txt = dreamjobs_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
             this.change('dreamjobs');
          break;
          case 'dreamjobspro':
             this.companyName = this.companyName;
             this.titleCompany = 'Dreamjobs';
             this.txt = dreamjobspro_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
             this.change('dreamjobspro');

             if (this.txt != 'all') {
              this.cities(1);
             }             
          break;
          case 'elespectador':
             this.companyName = this.companyName;
             this.titleCompany = 'El Espectador';
             this.txt = espectador_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
             this.change('elespectador');
             this.pageofer = "2";//variable para modificar la cantidad de ofertas a mostrar
          break;
          case 'activos':
             this.companyName = this.companyName;
             this.titleCompany = 'Activos S.A.';
             this.txt = activos_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
             this.change('activos');

             if (this.txt != 'all') {
              this.cities(1);
             }
          break;
          default:
             this.companyName = 'dreamjobs';
             this.titleCompany = 'Dreamjobs';
          break;
        }
    });

    this.JobCompany(1);
    this.JobAll(1,this.pageofer);
    this.JobUrgent(1,this.pageofer);

    if (localStorage.getItem('location-lat') && localStorage.getItem('location-lng')) {
      this.longitude = parseFloat( localStorage.getItem('location-lng') );
      this.latitude = parseFloat( localStorage.getItem('location-lat') );
      this.message = 'Buscando ofertas';
      this.JobCompany(1);
      this.JobAll(1,this.pageofer);
      this.JobUrgent(1,this.pageofer);
      this.geoLocation(1);
    } else {
      this.geoLocation(1);
      this.JobCompany(1);
      this.JobAll(1,this.pageofer);
      this.JobUrgent(1,this.pageofer);
    }
    this.videoplayer.nativeElement.play();
  }

  @ViewChild('videoPlayer') videoplayer: any;

  searchFnAll(){
    this.JobAll(1,this.pageofer);
  }
  searchFnCompany(){
    this.JobCompany(1);
  }
  searchFnUrgent(){
    this.JobUrgent(1,this.pageofer);
  }

  geoLocation(tries) {
    this.message = this.message + '.';

      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
            position => {
                this.geolocationPosition = position;
                localStorage.setItem('location-lng', this.geolocationPosition.coords.longitude);
                localStorage.setItem('location-lat', this.geolocationPosition.coords.latitude);
                this.latitude = this.geolocationPosition.coords.latitude;
                this.longitude = this.geolocationPosition.coords.longitude;
                // console.log(position);
                this.message = 'Buscando ofertas';
                this.JobCompany(1);
                this.JobAll(1,this.pageofer);
                this.JobUrgent(1,this.pageofer);
            },
            error => {
                switch (error.code) {
                    case 1:
                        console.log('Permission Denied');
                        break;
                    case 2:
                        console.log('Position Unavailable');
                        break;
                    case 3:
                        console.log('Timeout ' + tries);
                        this.geoLocation(tries + 1);
                        break;
                }
            },
            {
              enableHighAccuracy: false,
              timeout: 10000
            }
        );
      };
    // console.log(this.longitude);
    // console.log(this.latitude);
  }

  isCompany(name) {
        return this.dir_name + name;
   }

  getImage(name) {
    return 'url("assets/images/' + this.companyName + '/' + name + '")';
  }


  getStyle() {
    const style = {
      // CSS Dreamjobs
      'navbar-custom-dj': this.companyName == 'dreamjobs',
      // 'bg-dark-dj': this.companyName == 'dreamjobs',
      'btn.btn-d-dreamjobs': this.companyName == 'dreamjobs',
      'bg-gradientdj': this.companyName == 'dreamjobs',


      // CSS Dreamjobspro
      'navbar-custom-djpro': this.companyName == 'dreamjobspro',
      // 'bg-dark-djpro': this.companyName == 'dreamjobspro',
      'btn.btn-d-dreamjobspro': this.companyName == 'dreamjobspro',
      'bg-gradientdjpro': this.companyName == 'dreamjobspro',
      'bg-darkdjpro link': this.companyName == 'dreamjobspro',
      // 'img-logodjpro': this.companyName == 'dreamjobspro',

      // CSS El Espectador
      'navbar-custom-elespectador': this.companyName == 'elespectador',
      'btn.btn-d-elespectador': this.companyName == 'elespectador',
      // 'bg-dark-elespectador':this.companyName == 'dreamjobs',

      // CSS Activos S.A
      'navbar-custom-activos':this.companyName == 'activos',
      'bg-dark-activos':this.companyName == 'activos',
      'link':this.companyName == 'activos',
      'bg-darkactivos a.link:hover, bg-darkactivos a.link:focus':this.companyName == 'activos',
    };
    return style;
  }

  JobAll(page, page2) {

    if (this.searchAll == ''){
      this.jobService.getJobAll(this.latitude, this.longitude, 0, page, this.searchAll, page2)
      .then((result: any) => {
        // console.log(result);
          this.jobsAll = result.jobs;
          this.totalAll = result.pagination.total;
          this.pagesAll = result.pagination.pages;
          this.maxAll = result.pagination.pageCount;
          this.onloadingAll = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }else{
      // console.log("entra qui")
      this.jobService.getJobAll(this.latitude, this.longitude, 0, page, this.searchAll, page2)
      .then((result: any) => {
        // console.log(result);
          this.jobsAll = result.jobs;
          this.totalAll = result.pagination.total;
          this.pagesAll = result.pagination.pages;
          this.maxAll = result.pagination.pageCount;
          this.onloadingAll = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }
  }

  JobUrgent(page, page2) {
    if (this.searchUrgent == ''){
      this.jobService.getJobAll(this.latitude, this.longitude, 1, page, '', page2)
      .then((result: any) => {
        // console.log(result);
          this.jobsUrgent = result.jobs;
          this.totalUrgent = result.pagination.total;
          this.pagesUrgent = result.pagination.pages;
          this.maxUrgent = result.pagination.pageCount;
          this.onloadingUrgent = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );

    }else{
      this.jobService.getJobAll(this.latitude, this.longitude, 1, page, this.searchUrgent, page2)
      .then((result: any) => {
        // console.log(result);
          this.jobsUrgent = result.jobs;
          this.totalUrgent = result.pagination.total;
          this.pagesUrgent = result.pagination.pages;
          this.maxUrgent = result.pagination.pageCount;
          this.onloadingUrgent = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );

    }
    // this.jobService.getJobAll(this.geolocationPosition.coords.latitude, this.geolocationPosition.coords.longitude, 0, this.pageAll)

  }

  JobCompany(page) {
    const page_begin = ( ( page - 1 ) * 6 );
    let page_end = page_begin + 6;
    if (this.searchCompany == ''){
      this.jobService.getJobCompany(this.latitude, this.longitude, page)
      .then((result: any) => {
          this.jobsCompany = result.companies;
          this.totalCompany = result.company_total;

          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }
          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCompany = this.pageCompany;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCompany = false;
        }, (err) => {
          this.errorMessage = <any>Error
        }
    );
    }else{
      this.jobService.getJobCompany(this.latitude, this.longitude, page, this.searchCompany)
      .then((result: any) => {
          this.jobsCompany = result.companies;
          this.totalCompany = result.company_total;
          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }
          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCompany = this.pageCompany;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCompany = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }
  }

  cities(page) {
    const page_begin = ( ( page - 1 ) * 6 );
    let page_end = page_begin + 6;
    if (this.searchCity == ''){
      this.jobService.getJobCity(this.latitude, this.longitude, this.txt.company, page)
      .then((result: any) => {
          this.jobsCity = result.jobs;
          this.totalCity = result.jobs.length;
        
          if (page_end > this.totalCity) {
            page_end = this.totalCity;
          }
          this.jobsCitySlice = this.jobsCity.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCity = this.pageCity;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCity = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
    );
    }else{
      this.jobService.getJobCity(this.latitude, this.longitude, this.txt.company, page)
      .then((result: any) => {
          this.jobsCity = result.jobs;
          this.totalCity = result.jobs.length;
          
          if (page_end > this.totalCity) {
            page_end = this.totalCity;
          }
          this.jobsCitySlice = this.jobsCity.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCity = this.pageCity;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCity = false;
          // console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }
}

  goToJob(uuid) {
    this.router.navigateByUrl('https://user.dreamjobs.com.co/job/' + uuid);
  }

  getUpdateAll(event) {
    console.log(event);
    this.JobAll(event,this.pageofer);
  }

  getUpdateUrgent(event) {
    console.log(event);
    this.JobUrgent(event,this.pageofer);
  }

  getUpdateCompany(event) {
    console.log(event);
    const page_begin = ( ( event - 1 ) * 6 );
          let page_end = page_begin + 6;
          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }

          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
  }

  getUpdateCity(event) {
    // console.log(event);
    const page_begin = ( ( event - 1 ) * 6 );
          let page_end = page_begin + 6;
          if (page_end > this.totalCity) {
            page_end = this.totalCity;
          }

          this.jobsCitySlice = this.jobsCity.slice(page_begin, page_end);
  }

  change(c) {
        switch (c) {
          case 'dreamjobs':
             this.txthv = txt_hv;
             this.imgchatbots_dir = 'assets/images/feat_1.png';
             this.imgkanban_dir = 'assets/images/feat_2.png';
          break;
          case 'dreamjobspro':
             this.txthv = txt_hv1;
             this.imgchatbots_dir = 'assets/images/feat_8.png';
             this.imgkanban_dir = 'assets/images/feat_2.png';
             this.imggd_dir = 'assets/images/feat_7.png';
          break;
          case 'elespectador':
             this.txthv = txt_hv;
             this.imgchatbots_dir = 'assets/images/feat_1.png';
             this.imgkanban_dir = 'assets/images/feat_2.png';
          break;
          default:
             this.txthv = txt_hv2;
             this.imgchatbots_dir = 'assets/images/feat_7.png';
             this.imgkanban_dir = 'assets/images/feat_8.png';
          break;
        }
  }



}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts